// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borderRadius": "4px",
	"btnSmallBorderRadius": "4px",
	"btnLargeBorderRadius": "4px",
	"btnBorderRadius": "4px",
	"btnSmallHeight": "32px",
	"btnMediumHeight": "48px",
	"btnLargeHeight": "56px",
	"dialogBorderRadius": "8px",
	"checkBoxBorderRadius": "4px",
	"checkBoxSmallBorderRadius": "4px",
	"checkBoxLargeBorderRadius": "8px"
};
export default ___CSS_LOADER_EXPORT___;
